import {Mapper} from '@s-ui/domain'

export class FromRawsFaqsToFaqsListVOMapper extends Mapper {
  constructor({config, faqsInfoValueObjectFactory, faqStructuredDataSeoMapper, fromRawFaqToFaqListValueObjectMapper}) {
    super()
    this._config = config
    this._faqsInfoValueObjectFactory = faqsInfoValueObjectFactory
    this._faqStructuredDataSeoMapper = faqStructuredDataSeoMapper
    this._fromRawFaqToFaqListValueObjectMapper = fromRawFaqToFaqListValueObjectMapper
    this._type = '@type'
    this._faqPageType = 'FAQPage'
  }

  _getFaqSEO = ({faqs}) => {
    if (!faqs) return []

    const seoFaqDataStructure = faqs.find(faq => faq[this._type] === this._faqPageType) || {}
    return this._faqStructuredDataSeoMapper.map({
      seoFaqDataStructure
    })
  }

  _getFaqs = ({faqs}) => {
    if (!faqs) return []

    const localizedFaqs = faqs.find(faq => faq[this._type] === this._faqPageType) || {}

    return this._fromRawFaqToFaqListValueObjectMapper.map({
      faqs: localizedFaqs?.mainEntity || []
    })
  }

  map = data => {
    const {faqs} = data

    return this._faqsInfoValueObjectFactory({
      faqs: this._getFaqs({faqs}),
      seoFaqs: this._getFaqSEO({faqs})
    })
  }
}
